if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();

        this.currentIndex = 0;
        this.content = this.querySelector('.product-media-modal__content');
        this.prevButton = this.querySelector('[data-modal-prev]');
        this.nextButton = this.querySelector('[data-modal-next]');
        this.counterCurrent = this.querySelector('[data-modal-current]');
        this.counterTotal = this.querySelector('[data-modal-total]');
        this.dots = Array.from(this.querySelectorAll('[data-modal-dot]'));

        if (this.prevButton) {
          this.prevButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.step(-1);
          });
        }
        if (this.nextButton) {
          this.nextButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.step(1);
          });
        }
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', (event) => {
            event.stopPropagation();
            this.goTo(i);
          });
        });

        // Don't let clicks on the image or the nav controls dismiss the modal
        // (the media-modal base closes on any mouse pointerup outside the media).
        this.addEventListener(
          'pointerup',
          (event) => {
            if (
              event.pointerType === 'mouse' &&
              event.target.closest(
                '.product-media-modal__nav, .product-media-modal__dots, .product-media-modal__counter, .product-media-modal__content img, .product-media-modal__content video, .product-media-modal__content model-viewer, deferred-media, product-model'
              )
            ) {
              event.stopPropagation();
            }
          },
          true
        );

        // Keyboard arrows
        this.addEventListener('keydown', (event) => {
          if (!this.hasAttribute('open')) return;
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.step(1);
          } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.step(-1);
          }
        });

        // Wheel / trackpad — one image at a time
        this.wheelLocked = false;
        this.addEventListener(
          'wheel',
          (event) => {
            if (!this.hasAttribute('open') || this.mediaItems().length < 2) return;
            event.preventDefault();
            if (this.wheelLocked) return;
            const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
            if (Math.abs(delta) < 8) return;
            this.wheelLocked = true;
            this.step(delta > 0 ? 1 : -1);
            setTimeout(() => {
              this.wheelLocked = false;
            }, 450);
          },
          { passive: false }
        );

        // Touch swipe — one image at a time
        this.touchStartX = null;
        this.addEventListener(
          'touchstart',
          (event) => {
            this.touchStartX = event.changedTouches[0].clientX;
            this.touchStartY = event.changedTouches[0].clientY;
          },
          { passive: true }
        );
        this.addEventListener(
          'touchend',
          (event) => {
            if (this.touchStartX === null) return;
            const dx = event.changedTouches[0].clientX - this.touchStartX;
            const dy = event.changedTouches[0].clientY - this.touchStartY;
            if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
              this.step(dx < 0 ? 1 : -1);
            }
            this.touchStartX = null;
          },
          { passive: true }
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        const items = this.mediaItems();
        const openedId = this.openedBy ? this.openedBy.getAttribute('data-media-id') : null;
        let index = items.findIndex((el) => el.getAttribute('data-media-id') === openedId);
        if (index < 0) index = 0;
        this.goTo(index);
      }

      mediaItems() {
        if (!this.content) return [];
        return Array.from(this.content.querySelectorAll('[data-media-id]'));
      }

      step(direction) {
        this.goTo(this.currentIndex + direction);
      }

      goTo(index) {
        const items = this.mediaItems();
        const total = items.length;
        if (!total) return;

        index = ((index % total) + total) % total; // wrap around
        this.currentIndex = index;

        items.forEach((el, i) => el.classList.toggle('active', i === index));

        const activeMedia = items[index];
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube') &&
          typeof activeMedia.loadContent === 'function'
        ) {
          activeMedia.loadContent();
        }

        if (this.counterCurrent) this.counterCurrent.textContent = index + 1;
        if (this.counterTotal) this.counterTotal.textContent = total;
        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));

        if (this.content) this.content.scrollTop = 0;
      }
    }
  );
}
